import { BASE_URL } from '@/config'

export async function sendFile(file, customName, type = 'file') {
  const formData = new FormData()
  console.log('Enviando arquivo:', file)
  const fieldName = type === 'cover' ? 'cover' : 'file'
  formData.append(fieldName, file)

  if (customName) {
    formData.append('name', customName)
  }

  const endpoint =
    type === 'cover'
      ? `${BASE_URL}/docs/upload/cover`
      : `${BASE_URL}/docs/upload`

  try {
    const response = await fetch(endpoint, {
      method: 'POST',
      body: formData,
    })

    if (!response.ok) {
      const errorData = await response.json()
      console.error('Erro ao enviar o arquivo:', errorData)
      throw new Error(errorData.message || 'Erro ao enviar o arquivo')
    }

    const data = await response.json()
    console.log('Upload concluído:', data)
    return data
  } catch (error) {
    console.error('Erro ao enviar o arquivo:', error)
    throw error
  }
}

export async function getFilesBase64ByFileName(fileName, type = 'file') {
  try {
    const encodedFileName = encodeURIComponent(fileName)
    const query = type === 'cover' ? '?type=cover' : ''
    const response = await fetch(
      `${BASE_URL}/docs/base64/${encodedFileName}${query}`
    )

    if (!response.ok) {
      let errorMessage = `Erro ${response.status}`
      try {
        const errorData = await response.json()
        errorMessage = errorData.message || errorMessage
      } catch {
        // resposta não era JSON
      }
      throw new Error(errorMessage)
    }

    const data = await response.json()
    return data
  } catch (error) {
    console.error(`Erro ao buscar arquivo '${fileName}':`, error.message)
    throw error
  }
}

//Deletar arquivo pelo nome

export async function deleteFilesByName(filename, type = null) {
  try {
    const query = type ? `?type=${encodeURIComponent(type)}` : ''
    const response = await fetch(
      `${BASE_URL}/docs/delete/${encodeURIComponent(filename)}${query}`,
      {
        method: 'DELETE',
      }
    )

    const data = await response.json()

    if (!response.ok) {
      throw new Error(data.message || 'Erro ao deletar arquivo')
    }

    return data
  } catch (error) {
    console.error('Erro ao deletar arquivo:', error)
    throw error
  }
}

export async function sendDocFile(dataFile) {
  console.log('Enviando arquivo:', dataFile)

  if (!dataFile) {
    console.error('Nenhum arquivo fornecido para upload.')
    throw new Error('Nenhum arquivo fornecido para upload.')
  }
  try {
    const response = await fetch(`${BASE_URL}/docs/docfile`, {
      method: 'POST',
      body: dataFile,
    })

    if (!response.ok) {
      const errorData = await response.json()
      console.error('Erro ao enviar o arquivo:', errorData)
      throw new Error(errorData.message || 'Erro ao enviar o arquivo')
    }

    const data = await response.json()
    console.log('Upload concluído:', data)
    return data
  } catch (error) {
    console.error('Erro ao enviar o arquivo:', error)
    throw error
  }
}
